export default __webpack_public_path__ + "src/images/packages/bakubung-villas/6cce28196baf1674d52bd2528d4d29c8-3.jpg";